module.exports = __webpack_public_path__ + "static/media/sticker.e2bf44e1.png";